var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "pa-1", attrs: { fluid: "" } },
    [
      _c(
        "v-form",
        { ref: "form" },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                _vm._l(_vm.delegation.transport, function(item, index) {
                  return _c(
                    "v-card",
                    { key: index, staticStyle: { "margin-bottom": "15px" } },
                    [
                      _c(
                        "v-card-title",
                        {
                          staticClass: "grey lighten-5 py-2",
                          class: {
                            "py-2":
                              _vm.$store.state.Delegation.readonly === true
                          }
                        },
                        [
                          _c("h5", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("delegation.form.transportFragment")
                              ) +
                                " " +
                                _vm._s(index + 1)
                            )
                          ]),
                          _c("v-spacer"),
                          _vm.$store.state.Delegation.readonly !== true
                            ? _c(
                                "v-tooltip",
                                {
                                  attrs: { top: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                {
                                                  attrs: { icon: "" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.duplicateTransport(
                                                        item
                                                      )
                                                    }
                                                  }
                                                },
                                                on
                                              ),
                                              [
                                                _c("v-icon", [
                                                  _vm._v("fa-copy")
                                                ])
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "delegation.form.duplicateThisTransportFragment"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.$store.state.Delegation.readonly !== true
                            ? _c(
                                "v-tooltip",
                                {
                                  attrs: { top: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                {
                                                  attrs: { icon: "" },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.removeTransport(
                                                        item
                                                      )
                                                    }
                                                  }
                                                },
                                                on
                                              ),
                                              [_c("v-icon", [_vm._v("close")])],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "delegation.form.removeThisTransportFragment"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        [
                          _c("first-row", {
                            attrs: {
                              "model-amount-validation":
                                _vm.delegationErrors.transport[index]
                                  .amount_in_currency,
                              "model-amount": item.amount_in_currency,
                              "model-booking-id-validation":
                                _vm.delegationErrors.transport[index]
                                  .booking_id,
                              "model-booking-id": item.booking_id,
                              "model-booking-ticket": item.booking_ticket,
                              "model-currency-validation":
                                _vm.delegationErrors.transport[index].currency,
                              "model-currency": item.currency,
                              "model-file-id-validation":
                                _vm.delegationErrors.transport[index].file_id,
                              "model-file-id": item.file_id,
                              "model-settlement-type-id-validation":
                                _vm.delegationErrors.transport[index]
                                  .settlement_type_id,
                              "model-settlement-type-id":
                                item.settlement_type_id,
                              "model-transport-type-validation":
                                _vm.delegationErrors.transport[index]
                                  .transport_type,
                              "model-transport-type": item.transport_type,
                              "model-vehicle-id-validation":
                                _vm.delegationErrors.transport[index]
                                  .vehicle_id,
                              "model-vehicle-id": item.vehicle_id,
                              "model-comment": item.comment,
                              "model-comment-validation":
                                _vm.delegationErrors.transport[index].comment
                            },
                            on: {
                              "update:modelAmount": function($event) {
                                return _vm.$set(
                                  item,
                                  "amount_in_currency",
                                  $event
                                )
                              },
                              "update:model-amount": function($event) {
                                return _vm.$set(
                                  item,
                                  "amount_in_currency",
                                  $event
                                )
                              },
                              "update:modelBookingId": function($event) {
                                return _vm.$set(item, "booking_id", $event)
                              },
                              "update:model-booking-id": function($event) {
                                return _vm.$set(item, "booking_id", $event)
                              },
                              "update:modelBookingTicket": function($event) {
                                return _vm.$set(item, "booking_ticket", $event)
                              },
                              "update:model-booking-ticket": function($event) {
                                return _vm.$set(item, "booking_ticket", $event)
                              },
                              "update:modelCurrency": function($event) {
                                return _vm.$set(item, "currency", $event)
                              },
                              "update:model-currency": function($event) {
                                return _vm.$set(item, "currency", $event)
                              },
                              "update:modelFileId": function($event) {
                                return _vm.$set(item, "file_id", $event)
                              },
                              "update:model-file-id": function($event) {
                                return _vm.$set(item, "file_id", $event)
                              },
                              "update:modelSettlementTypeId": function($event) {
                                return _vm.$set(
                                  item,
                                  "settlement_type_id",
                                  $event
                                )
                              },
                              "update:model-settlement-type-id": function(
                                $event
                              ) {
                                return _vm.$set(
                                  item,
                                  "settlement_type_id",
                                  $event
                                )
                              },
                              "update:modelTransportType": function($event) {
                                return _vm.$set(item, "transport_type", $event)
                              },
                              "update:model-transport-type": function($event) {
                                return _vm.$set(item, "transport_type", $event)
                              },
                              "update:modelVehicleId": function($event) {
                                return _vm.$set(item, "vehicle_id", $event)
                              },
                              "update:model-vehicle-id": function($event) {
                                return _vm.$set(item, "vehicle_id", $event)
                              },
                              importRailRoute: function(bookingItem) {
                                _vm.importRailRoute(item, bookingItem)
                              },
                              importRouteBack: function(bookingItem) {
                                _vm.importRouteBack(item, bookingItem)
                              },
                              importRouteTo: function(bookingItem) {
                                _vm.importRouteTo(item, bookingItem)
                              },
                              "update:modelComment": function($event) {
                                return _vm.$set(item, "comment", $event)
                              },
                              "update:model-comment": function($event) {
                                return _vm.$set(item, "comment", $event)
                              }
                            }
                          }),
                          _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-col",
                                { attrs: { md: "3", sm: "6", cols: "12" } },
                                [
                                  _c("location-ajax-select", {
                                    attrs: {
                                      placeholder: item.from_place_text,
                                      "select-model": item.from_place_id,
                                      "select-text": item.from_place_text,
                                      label: _vm.$t(
                                        "delegation.form.fields.transport.startPlace.name"
                                      ),
                                      "select-validation":
                                        _vm.delegationErrors.transport[index]
                                          .from_place_id,
                                      defaultItems: _vm.startLocationDefaultItems(
                                        item
                                      ),
                                      readonly:
                                        _vm.$store.state.Delegation.readonly ===
                                        true
                                    },
                                    on: {
                                      "update:placeholder": function($event) {
                                        return _vm.$set(
                                          item,
                                          "from_place_text",
                                          $event
                                        )
                                      },
                                      "update:selectModel": [
                                        function($event) {
                                          return _vm.$set(
                                            item,
                                            "from_place_id",
                                            $event
                                          )
                                        },
                                        function($event) {
                                          return _vm.recalculateGoogleMapsDistance(
                                            item
                                          )
                                        }
                                      ],
                                      "update:select-model": function($event) {
                                        return _vm.$set(
                                          item,
                                          "from_place_id",
                                          $event
                                        )
                                      },
                                      "update:selectText": function($event) {
                                        return _vm.$set(
                                          item,
                                          "from_place_text",
                                          $event
                                        )
                                      },
                                      "update:select-text": function($event) {
                                        return _vm.$set(
                                          item,
                                          "from_place_text",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "3", sm: "6", cols: "12" } },
                                [
                                  _c("date-time-picker-computed", {
                                    attrs: {
                                      "date-time-validation":
                                        _vm.delegationErrors.transport[index]
                                          .start_date,
                                      "default-button": true,
                                      "default-value": _vm.startDateDefaultValue(
                                        item
                                      ),
                                      label: _vm.$t(
                                        "delegation.form.fields.transport.startDate.name"
                                      ),
                                      dateTimeModel: item.start_date,
                                      readonly:
                                        _vm.$store.state.Delegation.readonly ===
                                        true
                                    },
                                    on: {
                                      "update:dateTimeModel": function($event) {
                                        return _vm.$set(
                                          item,
                                          "start_date",
                                          $event
                                        )
                                      },
                                      "update:date-time-model": function(
                                        $event
                                      ) {
                                        return _vm.$set(
                                          item,
                                          "start_date",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "3", sm: "6", cols: "12" } },
                                [
                                  _c("location-ajax-select", {
                                    attrs: {
                                      placeholder: item.to_place_text,
                                      "select-text": item.to_place_text,
                                      "select-model": item.to_place_id,
                                      label: _vm.$t(
                                        "delegation.form.fields.transport.endPlace.name"
                                      ),
                                      "select-validation":
                                        _vm.delegationErrors.transport[index]
                                          .to_place_id,
                                      defaultItems: _vm.endLocationDefaultItems(
                                        item
                                      ),
                                      readonly:
                                        _vm.$store.state.Delegation.readonly ===
                                        true
                                    },
                                    on: {
                                      "update:selectText": function($event) {
                                        return _vm.$set(
                                          item,
                                          "to_place_text",
                                          $event
                                        )
                                      },
                                      "update:select-text": function($event) {
                                        return _vm.$set(
                                          item,
                                          "to_place_text",
                                          $event
                                        )
                                      },
                                      "update:selectModel": [
                                        function($event) {
                                          return _vm.$set(
                                            item,
                                            "to_place_id",
                                            $event
                                          )
                                        },
                                        function($event) {
                                          return _vm.recalculateGoogleMapsDistance(
                                            item
                                          )
                                        }
                                      ],
                                      "update:select-model": function($event) {
                                        return _vm.$set(
                                          item,
                                          "to_place_id",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { md: "3", sm: "6", cols: "12" } },
                                [
                                  _c("date-time-picker-computed", {
                                    attrs: {
                                      "date-time-validation":
                                        _vm.delegationErrors.transport[index]
                                          .end_date,
                                      "default-button": true,
                                      "default-value": _vm.endDateDefaultValue(
                                        item
                                      ),
                                      label: _vm.$t(
                                        "delegation.form.fields.transport.endDate.name"
                                      ),
                                      dateTimeModel: item.end_date,
                                      readonly:
                                        _vm.$store.state.Delegation.readonly ===
                                        true
                                    },
                                    on: {
                                      "update:dateTimeModel": function($event) {
                                        return _vm.$set(
                                          item,
                                          "end_date",
                                          $event
                                        )
                                      },
                                      "update:date-time-model": function(
                                        $event
                                      ) {
                                        return _vm.$set(
                                          item,
                                          "end_date",
                                          $event
                                        )
                                      }
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          item.transport_type ===
                            _vm.transportType.TRANSPORT_CAR_RENTAL ||
                          item.transport_type ===
                            _vm.transportType.TRANSPORT_CAR
                            ? _c(
                                "v-row",
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { sm: "3", cols: "6" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          "error-messages":
                                            _vm.delegationErrors.transport[
                                              index
                                            ].distance,
                                          label: _vm.$t(
                                            "delegation.form.fields.transport.distance.name"
                                          ),
                                          readonly:
                                            _vm.$store.state.Delegation
                                              .readonly === true
                                        },
                                        model: {
                                          value: item.distance,
                                          callback: function($$v) {
                                            _vm.$set(item, "distance", $$v)
                                          },
                                          expression: "item.distance"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { sm: "3", cols: "6" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          disabled: "",
                                          label: _vm.$t(
                                            "delegation.form.fields.transport.googleMapsDistance.name"
                                          )
                                        },
                                        model: {
                                          value: item.google_maps_api_distance,
                                          callback: function($$v) {
                                            _vm.$set(
                                              item,
                                              "google_maps_api_distance",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "item.google_maps_api_distance"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { sm: "6", cols: "12" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          "error-messages":
                                            _vm.delegationErrors.transport[
                                              index
                                            ].comment,
                                          label: _vm.$t(
                                            "delegation.form.fields.transport.comment.name"
                                          ),
                                          readonly:
                                            _vm.$store.state.Delegation
                                              .readonly === true
                                        },
                                        model: {
                                          value: item.comment,
                                          callback: function($$v) {
                                            _vm.$set(item, "comment", $$v)
                                          },
                                          expression: "item.comment"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          item.transport_type ===
                          _vm.transportType.TRANSPORT_CAR_RENTAL
                            ? _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { sm: "3", cols: "6" } },
                                    [
                                      _c(
                                        "text-field-with-copy-default-button",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "delegation.form.fields.transport.carRentalName.name"
                                            ),
                                            model: item.car_rental_name,
                                            "error-messages":
                                              _vm.delegationErrors.transport[
                                                index
                                              ].car_rental_name,
                                            "default-button": true,
                                            "default-value":
                                              _vm.$store.getters[
                                                "Delegation/lastCarRentalName"
                                              ],
                                            readonly:
                                              _vm.$store.state.Delegation
                                                .readonly === true
                                          },
                                          on: {
                                            "update:model": function($event) {
                                              return _vm.$set(
                                                item,
                                                "car_rental_name",
                                                $event
                                              )
                                            }
                                          }
                                        }
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { sm: "3", cols: "6" } },
                                    [
                                      _c(
                                        "text-field-with-copy-default-button",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "delegation.form.fields.transport.carRentalVehicleName.name"
                                            ),
                                            model: item.car_rental_vehicle_name,
                                            "error-messages":
                                              _vm.delegationErrors.transport[
                                                index
                                              ].car_rental_vehicle_name,
                                            "default-button": true,
                                            "default-value":
                                              _vm.$store.getters[
                                                "Delegation/lastCarRentalVehicleName"
                                              ],
                                            readonly:
                                              _vm.$store.state.Delegation
                                                .readonly === true
                                          },
                                          on: {
                                            "update:model": function($event) {
                                              return _vm.$set(
                                                item,
                                                "car_rental_vehicle_name",
                                                $event
                                              )
                                            }
                                          }
                                        }
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    { attrs: { sm: "6", cols: "12" } },
                                    [
                                      _c(
                                        "text-field-with-copy-default-button",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "delegation.form.fields.transport.carRentalVehicleModel.name"
                                            ),
                                            model:
                                              item.car_rental_vehicle_model,
                                            "error-messages":
                                              _vm.delegationErrors.transport[
                                                index
                                              ].car_rental_vehicle_model,
                                            "default-button": true,
                                            "default-value":
                                              _vm.$store.getters[
                                                "Delegation/lastCarRentalVehicleModel"
                                              ],
                                            readonly:
                                              _vm.$store.state.Delegation
                                                .readonly === true
                                          },
                                          on: {
                                            "update:model": function($event) {
                                              return _vm.$set(
                                                item,
                                                "car_rental_vehicle_model",
                                                $event
                                              )
                                            }
                                          }
                                        }
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          item.transport_type ===
                            _vm.transportType.TRANSPORT_OTHER &&
                          item.settlement_type_id !== 7
                            ? _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { sm: "12", cols: "12" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          "error-messages":
                                            _vm.delegationErrors.transport[
                                              index
                                            ].comment,
                                          label: _vm.$t(
                                            "delegation.form.fields.transport.comment.name"
                                          ),
                                          readonly:
                                            _vm.$store.state.Delegation
                                              .readonly === true
                                        },
                                        model: {
                                          value: item.comment,
                                          callback: function($$v) {
                                            _vm.$set(item, "comment", $$v)
                                          },
                                          expression: "item.comment"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                }),
                1
              ),
              _vm.$store.state.Delegation.readonly !== true
                ? _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "accent" },
                          on: { click: _vm.addTransport }
                        },
                        [_vm._v(_vm._s(_vm.$t("global.add")))]
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c("collapse-other-transport-panel", {
                    attrs: {
                      "model-other": _vm.delegation.other,
                      readonly: _vm.$store.state.Delegation.readonly === true,
                      clearable: _vm.$store.state.Delegation.readonly !== true
                    },
                    on: {
                      "update:modelOther": function($event) {
                        return _vm.$set(_vm.delegation, "other", $event)
                      },
                      "update:model-other": function($event) {
                        return _vm.$set(_vm.delegation, "other", $event)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }